<script>
export default {
    name: "ConfirmPostAllPaymentsModal",

    data() {

        return {
          memo: ``,
        };
    },

    props: {

        showModal: Boolean,
        combinedPayments: Array,
        patient: Object,
    },

    computed: {

      totalAmount() {
        if(!this.combinedPayments.length) return 0;

        return this.combinedPayments.map(payment => parseFloat(payment.amount))
          .reduce((sum, amount) => sum + amount);
      },

      aggCombinedPayments() {

          return {
            userName: this.$root.username,
            memo: this.memo,
            patientName: this.patient.names,
            visitNo: this.patient.visitNo,
            patientID: this.patient.patienT_ID,
            totalAmount: this.totalAmount,
            combinedDetails: this.combinedPayments.length ? this.combinedPayments.map(payment => {
              return {
                id: payment.combinedDetailID
              };
            }) : [],
          };
      },
    },

    methods: {

        saveCombinedInvoice() {

            this.$root.loading=true;
            this.$http.post(`Accounts/PostCombinedPaynInvoice`, this.aggCombinedPayments)
              .then(response => {
                this.$emit(`refresh`);
                this.memo = ``;
                this.$root.loading=false;
                this.$emit(`closeModal`);
                this.$emit(`print`,response.data.invoiceNo);
            }).catch(() => { this.$root.loading=false; });
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="w-10/12 md:w-1/4">
      <template v-slot:title>
        <h5 class="font-medium text-sm">Confirm Post Combined Invoice</h5>
      </template>
      <template v-slot:modal-body>
        <div class="w-full -m-3">
            <label for="grid-confirm-memo" class="label-control">Memo:</label>
            <textarea id="grid-confirm-memo"
              v-model.trim="memo" 
              cols="30" rows="4" class="input-control input-sm text-xs">
            </textarea>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button 
            class="btn-danger btn-sm text-xs rounded mr-6" 
            @click="$emit(`closeModal`)">
                <i class="fa fa-times"></i> Close</button>
        <button 
            @click.prevent="saveCombinedInvoice"
            class="btn-primary btn-sm text-xs rounded">
                <i class="fa fa-save"></i> Post All Payments</button>
      </template>
    </tail-modal>
</template>